import PrivateRoute, { Router } from '@Components/app-layout/PrivateRoute';

import UsersGrid from '../components/Grid';
import { UserProvider } from '../store';

import UserFormLayout from './Form';

export default function UsersGridLayout() {
  return <UserProvider>
    <UsersGrid />
    <Router>
      <PrivateRoute path={["/settings/users/add", "/settings/users/:id"]} component={UserFormLayout} />
    </Router>
  </UserProvider>;
}
